import React from 'react';

import { ClickableIcon } from '~components';
import { faArrowUpRightFromSquare } from '~components/icon';

interface ComponentProps {
  id: string;
  url: string;
  label: string;
}

/**
 * Opens the record a row refers to, in a new tab.
 *
 * A new tab rather than a navigation, because the assistant commits each step as it is confirmed and
 * navigating away mid-run abandons a part-finished cutover. Checking a price plan or a budget before
 * ticking it is exactly what a provider should be doing here, so it must not cost them the run.
 *
 * `noopener,noreferrer` for the usual reason: without it the opened page gets a handle on this one
 * through `window.opener`.
 */
const OpenRecordAction: React.FC<ComponentProps> = ({ id, url, label }) => (
  <div className="d-flex justify-content-center align-items-center w-100">
    <ClickableIcon
      id={id}
      dataCy={id}
      icon={faArrowUpRightFromSquare}
      toolTip={label}
      ariaLabel={label}
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
    />
  </div>
);

export default OpenRecordAction;
